import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Account, AccountTariff } from '@personal-area/global/accounts/models';
import { Role } from '@personal-area/global/users/models';

const tariffMap = new Map<AccountTariff, AccountTariff>([
  [AccountTariff.cent, AccountTariff.cent],
  [AccountTariff.demoCent, AccountTariff.cent],
  [AccountTariff.stand, AccountTariff.stand],
  [AccountTariff.demoStand, AccountTariff.stand],
  [AccountTariff.partner, AccountTariff.partner],
  [AccountTariff.professional, AccountTariff.professional],
  [AccountTariff.demoProfessional, AccountTariff.professional],
  [AccountTariff.standardFSA, AccountTariff.stand],
  [AccountTariff.demoStandardFSA, AccountTariff.demoStand],
]);

@Pipe({
  name: 'accountName',
  standalone: true,
})
export class AccountNamePipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {}

  transform(account: Account, includeServer = false, useCustomName = true): string {
    if (account.name && useCustomName) {
      return account.name;
    }
    const tariffName = tariffMap.get(account.tariff);

    if (account.type === Role.TradingPlatform) {
      return (includeServer ? this._translateService.instant('open-account.label.tp') : '')
        + ` ${this._translateService.instant(`register-account.label.${tariffName}`)}`
        + ` ${account.id}`
    }

    return this._translateService.instant((`register-account.label.${tariffName}`))
      + (includeServer ? ` ${account.server.type.toUpperCase()}` : '')
      + ` ${account.login}`;
  }
}
